import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "You, take a break",
  "description": "",
  "published": "2013-12-20T00:00:00.000Z",
  "redirect_from": ["/blog/you-take-a-break/swizec/6464"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`[`}{`I sent this out to the `}<a parentName="em" {...{
          "href": "http://swiz.ec/nightowls-list"
        }}>{`Nightowls bi-monthly`}</a>{` yesterday and it got a great response, so I'm reposting it here. Take a break.]`}</em></p>
    <p>{`Hey You,`}</p>
    <p>{`finally! That time of the year when the world slows down, people fly away for two weeks, and you can just work. Nobody there to bother you at all.`}</p>
    <p>{`Don't.`}</p>
    <p>{`I know it's a big temptation, I know it's the perfect time to start a side-project, or finish an old one. The perfect time to wrap up that refactoring job you've been sneaking into your task estimates ... I don't think there's been a holiday in the last few years that I didn't open a new Github repository.`}</p>
    <p>{`Don't.`}</p>
    <p>{`You won't finish that side-project. You'll start with enthusiasm, then realise that hey maybe you actually don't have as much time as you thought.`}</p>
    <p>{`Just relax. It's going to be fine.`}</p>
    <p>{`Let's play a game right now. Stop reading. Lean back. Stretch. Close your eyes. Do nothing for two minutes. Just breathe.`}</p>
    <p>{`Hard, right? You wanted to at least run the test suite or something while you're waiting. Just so the time wouldn't be completely lost.`}</p>
    <p>{`So how the hell are we going to do this for a week? Two weeks? Impossible!`}</p>
    <p>{`Sure, there's a bunch of work to finish. But there's always a bunch of work to finish. And I completely understand all the business owners who are tearing their hair out about the next two weeks. What ever will happen to the company? So much lost productivity!`}</p>
    <p>{`Don't worry, you'll make it all up when you get back. I promise.`}</p>
    <p>{`Even if you're a freelancer. Just ... chill. I know you want to work, I know you want to get ahead of the competition. Don't worry about it. You'll be even awesomer after the break.`}</p>
    <p>{`If you're just a nerd who likes staying at home with their computer, stop. Go out. Meet people. Party.`}</p>
    <p>{`Dance like nobody's watching.`}</p>
    <p>{`The biggest forum for tech nerds in Slovenia just closes down on New Year's Eve. Go there and you're greeted with `}<em parentName="p">{`"Step away from the computer. Party."`}</em></p>
    <p>{`I used to think that was stupid. But it's really really awesome. Listen to their advice. Go have fun.`}</p>
    <p>{`Let's make a deal.`}</p>
    <p>{`I will personally find a way to slap anyone who writes a line of code between the 30th of December and the 2nd of January. I'll do it through TCP/IP if I have to.`}</p>
    <p>{`But! If you do take a few days off, and you like it, I will buy you a beer or coffee or a slice of cake or whatever when I'm in your part of the world. Deal?`}</p>
    <p>{`No links today. No productivity tips. Go out and have fun. Come back fresh. Win.`}</p>
    <p>{`Cheers, ~Swizec`}</p>
    <p>{`PS: if you have any suggestions for new year's fun in new york, I'm all ears. See, I'm taking my own advice :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      